import React, { FC, useContext, useMemo } from 'react';

import TransclusionContext from '../_TransclusionContext';

export interface TranscludeProps {}

const Transclude: FC<TranscludeProps> = (props) => {
  const cache = useMemo(() => ({ transclusions: [] }), []);
  const { transclusions } = useContext(TransclusionContext);
  const { children } = useMemo(() => transclusions[transclusions.length - 1], [transclusions]);

  const newTransclusions = useMemo(() => {
    if (cache.transclusions.length === 0 && transclusions.length === 1) {
      return cache.transclusions;
    }

    const nextTransclusions = [...transclusions.slice(0, -1)];

    cache.transclusions = nextTransclusions;

    return cache.transclusions;
  }, [cache, transclusions]);

  const newContext = useMemo(() => ({ transclusions: newTransclusions }), [newTransclusions]);

  const renderedChildren = useMemo(() => (
    typeof children === 'function' ? children(props) : children
  ), [children, props]);

  return (
    <TransclusionContext.Provider value={newContext}>
      {renderedChildren}
    </TransclusionContext.Provider>
  );
};

export default Transclude;
